import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../core/services/alert/alert.service';
import { AuthStateService } from '../../core/services/auth-state/auth-state-service.service';

@Component({
  selector: 'app-order-freeze',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './order-freeze.component.html',
  styleUrl: './order-freeze.component.css',
})
export class OrderFreezeComponent implements OnInit {
  autoFreezeEnabled = true;
  isLoading = true;
  isSupplier = false;

  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private authStateService: AuthStateService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.isSupplier = this.authStateService.getAccountType() === 'supplier';
    if (this.isSupplier) {
      this.loadSetting();
    } else {
      this.isLoading = false;
    }
  }

  loadSetting(): void {
    this.isLoading = true;
    this.http.get<any>(`${environment.apiURL}account-settings/order-freeze`).subscribe({
      next: (res) => {
        this.autoFreezeEnabled = res.data?.auto_freeze_enabled ?? true;
        this.isLoading = false;
      },
      error: () => {
        this.autoFreezeEnabled = true;
        this.isLoading = false;
      },
    });
  }

  async toggleFreeze(): Promise<void> {
    const newValue = !this.autoFreezeEnabled;
    const messageKey = newValue
      ? 'settings.order_freeze.confirm_enable'
      : 'settings.order_freeze.confirm_disable';

    const result = await this.alertService.confirmation(
      messageKey,
      'swal_messages.confirm'
    );
    if (!result.isConfirmed) return;

    this.alertService.loading();
    this.http.put<any>(`${environment.apiURL}account-settings/order-freeze`, {
      auto_freeze_enabled: newValue,
    }).subscribe({
      next: (res) => {
        this.alertService.close();
        this.autoFreezeEnabled = res.data?.auto_freeze_enabled ?? newValue;
        this.alertService.success('swal_messages.account_settings.order_freeze_setting_updated');
      },
      error: (err) => {
        this.alertService.close();
        this.alertService.error(err?.error || 'swal_messages.error_occurred');
      },
    });
  }
}
